﻿module.exports = Dropdown;

function Dropdown(options) {
    let element = options.element;
    let menuElement = options.menuElement
    let windowElement = options.windowElement

    element.on('click', function (e) {
        if (menuElement.css('display') != 'none') {
            menuElement.css('display', 'none');
        } else {
            menuElement.css('display', 'block');
        }
    });

    menuElement.on('click', function (e) {
        e.stopPropagation();
    });

    windowElement.on('click', function (e) {
        if ($(e.target).closest(element).length) { return; }

        if (menuElement.css('display') !== 'none') {
            menuElement.css('display', 'none');
        }
    });
}